<template>
    <nuxt-link v-if="logoUrl" :to="navTo">
        <div class="card">
            <div class="logo-wrapper">
                <img :src="logoUrl" alt="Logo" loading="lazy" />
            </div>
            <h6 class="text-md md:text-xl font-medium text-primary">
                {{ title }}
            </h6>
        </div>
    </nuxt-link>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: '',
    },
    logoUrl: {
        type: String,
        default: '',
        required: true,
    },
    navTo: {
        type: String,
        default: '',
    },
});
</script>

<style lang="scss" scoped>
.card {
    border: 1px solid #dedede;
    padding: 24px;
    width: 100%;
    aspect-ratio: 1/1;
    position: relative;
    .logo-wrapper {
        display: flex;
        justify-items: center;
        height: 120px;
        img {
            margin: 0 auto;
            display: block;
            max-height: 120px;
            object-fit: contain;
        }
    }
    h6 {
        position: absolute;
        text-align: center;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        bottom: 24px;
    }
    @media (max-width: 767px),
        (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
        padding: 16px;
        .logo-wrapper {
            img {
                max-height: 56px;
            }
        }
    }

    @media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
        .logo-wrapper {
            img {
                max-height: 80px;
            }
        }
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
        .logo-wrapper {
            img {
                max-height: 64px;
            }
        }
    }
}
</style>
